import React from 'react'


const Footer = () => {
    return (
            <div id="site-footer">
               
                    <div className="footer-item footer-connect">
                        <p><a rel="noreferrer" href="mailto:connect@industry.global">connect@industry.global</a></p>
                    </div>
                    <div className="footer-item footer-social">
                        <p><a rel="noreferrer" href="https://instagram.com/industry______" target="_blank">Instagram</a> / <a href="https://twitter.com/INDUSTRY_____" target="_blank" rel="noreferrer">Twitter</a> / <a href="https://www.linkedin.com/company/industry-pdx-" target="_blank" rel="noreferrer">Linkedin</a></p>
                    </div>
                    <div className="footer-item footer-phone">
                        <p><a rel="noreferrer" href="tel:5038941437">503 894 1437</a></p>
                    </div>
              
            </div>

      
    )
}

export default Footer
